import { render, staticRenderFns } from "./ServiceQRcode.vue?vue&type=template&id=56453c3a&"
import script from "./ServiceQRcode.vue?vue&type=script&lang=js&"
export * from "./ServiceQRcode.vue?vue&type=script&lang=js&"
import style0 from "./ServiceQRcode.vue?vue&type=style&index=0&id=56453c3a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports